import NewDiagnosisModal from './DraggableModal';

export default NewDiagnosisModal;
